export default "__VITE_ASSET__CR74lHAn__"